import { Box, Button } from "@mui/material"
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom"
import { trackerApi } from "../../core/api/TrackerApi"
import { useAppContext } from "../../core/app/AppContextProvider"
import { AppState } from "../../core/app/AppReducer"
import AlwaysHintsTracker from "../hints/AlwaysHintsTracker"
import BarrenHintsTracker from "../hints/BarrenHintsTracker"
import DungeonTracker from "../hints/DungeonTracker"
import PathHintsTracker from "../hints/PathHintsTracker"
import SometimesHintsTracker from "../hints/SometimesHintsTracker"
import KeysanityTracking from "../keysanity/KeysanityTracking"
import MixPoolItemNotesTracker from "../mixpool/MixPoolItemNotesTracker"
import ShopsanityTracker from "../shop/ShopsanityTracker"
import TrialTracker from "../trials/TrialTracker"
import WarpTracker from "../warp/WarpTracker"
import ItemsTracker from "./ItemsTracker"
import LocationItemTracker from "./LocationItemTracker"
import { useQueryCheckCredentials } from "../../core/user/UserQuery";
import SphereTrackerDisplay from "../sphere/SphereTrackerDisplay";
import OutOfLogicDisplay from "../sphere/OutOfLogicDisplay";
import BaseTextField from "../../core/components/base/BaseTextField";
import { useState } from "react";
import Metronome from "../../metronome/Metronome";

interface MultiworldHintUpdate {
    id: number,
    location: string | null,
    goal: string | null,
    player: string | null,
    itemsSelf: Array<string>,
    itemsPlayer2: Array<string>,
    itemsPlayer3: Array<string>
}
const updateMultiworldHint = async (values: MultiworldHintUpdate) => {
    await trackerApi.callServicePost("/api/OoTItem/multiworld/update", values)
}

const HintsNotesTracker = () => {


    let appContext = useAppContext();
    let navigate = useNavigate();

    let { data: isAllowed } = useQueryCheckCredentials();


    let useItemTracker = useSelector((state: AppState) => state.ui.ootr.main.useItemTracker)
    let useItemTrackerReduce = useSelector((state: AppState) => state.ui.ootr.main.useItemTrackerReduce)
    let useSphereTracker = useSelector((state: AppState) => state.ui.ootr.main.useSphereTracker)
    let useLocationTracker = useSelector((state: AppState) => state.ui.ootr.main.useLocationTracker)
    let nbSometimes = useSelector((state: AppState) => state.ui.ootr.main.nbSometimes);
    let goals = useSelector((state: AppState) => state.ui.ootr.main.goals);

    let useScrubs = useSelector((state: AppState) => state.ui.ootr.main.useScrubSettings)
    let useMultiworld = useSelector((state: AppState) => state.ui.ootr.main.isMultiworld)

    let cowsanity = useSelector((state: AppState) => state.ui.ootr.main.isCowsanity)
    let scrubsanity = useSelector((state: AppState) => state.ui.ootr.main.isScrubsanity)

    let [lastLoc, setLastLoc] = useState<string>("")

    const updateMultiworldSpreadsheet = async () => {

        for (let key in Object.keys(goals)) {
            let goal = goals[key];

            let param: MultiworldHintUpdate = {
                id: Number(key) + 1,
                goal: goal.goal?.name ?? null,
                location: goal.location?.name ?? null,
                player: goal.player,
                itemsSelf: goal.items.slice(0, 3).map(x => x?.name ?? "") ?? [],
                itemsPlayer2: goal.items.slice(3, 5).map(x => x?.name ?? "") ?? [],
                itemsPlayer3: goal.items.slice(5, 7).map(x => x?.name ?? "") ?? []
            }
            updateMultiworldHint(param);
        }
    }

    return <Box display="flex" flexDirection="column">
        <Box width={"100%"}><Button onClick={() => navigate("/ootr/tracker/settings")}>Settings</Button>
            {appContext.isAuthenticated && appContext.user.isAdmin && <Button onClick={() => updateMultiworldSpreadsheet()}>Update MW</Button>}</Box>
        <Box component={"div"} display="flex" flexWrap="wrap" flexDirection="column" height={"80vh"} justifyContent={"flex-start"}>
            {(useItemTracker || useItemTrackerReduce) && <Box display={"flex"} >
                <ItemsTracker />

            </Box>}

            <PathHintsTracker />
            <Box display="flex" flexDirection={"row"}>
                <BarrenHintsTracker />
                <AlwaysHintsTracker direction="row" cowsanity={cowsanity} scrubsanity={scrubsanity} hintDistribution={useScrubs ? "scrubs" : useMultiworld ? "multiworld" : "s7"} />

            </Box>

            <SometimesHintsTracker nbSometimes={nbSometimes} />
            <Metronome bpm={150} title="Bongo Metronome" />
            <KeysanityTracking />
            
            <TrialTracker />
            <ShopsanityTracker />


            <WarpTracker />
            <DungeonTracker />
            {isAllowed.value && useSphereTracker && <SphereTrackerDisplay />} 
            {isAllowed.value && useSphereTracker && <Box display={"flex"}>
                <Box width={"100%"} textAlign={"center"} sx={{color: "red"}}>Out of Logic</Box>
                <OutOfLogicDisplay />
            </Box>}
            <Box display={"flex"} maxWidth={"300px"}>
                <BaseTextField multiline label="Last Loc" value={lastLoc} onChange={(v) => setLastLoc(v.currentTarget.value)}/>
            </Box>
            {useLocationTracker && <LocationItemTracker />}
            {/* <LocationItemTrackerFromItems /> */}
            <MixPoolItemNotesTracker />


        </Box>

    </Box>
}

export default HintsNotesTracker